export default "__VITE_ASSET__8fbd50a5__"